import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-783f485a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "setting" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, [
  /*#__PURE__*/_createElementVNode("span", null, "设为默认地址"),
  /*#__PURE__*/_createElementVNode("span", null, "提醒：下单时会优先使用该地址")
], -1))
const _hoisted_5 = { class: "footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 确认 ")

import {
  NavBar,
  Search,
  Checkbox,
  Form,
  CellGroup,
  Field,
  Area,
  Popup,
  Button,
  Toast,
} from "vant";
import { ref } from "vue";
import { areaList } from "@vant/area-data";
import { request } from "@/provide/fetch";

export default /*#__PURE__*/_defineComponent({
  name: 'CreateAddress',
  props: {
  editId: {
    type: String,
  },
},
  emits: ["change", "cancel"],
  setup(__props, { emit }) {

const props = __props



const userName = ref("");
const phone = ref("");
const detailAddress = ref("");
const result = ref("");
const isDefault = ref(false);
const showArea = ref(false);
const submitLoading = ref(false);
const onConfirm = (areaValues: any) => {
  console.log(areaValues);
  showArea.value = false;
  result.value = areaValues.selectedOptions
    .filter((item: any) => !!item)
    .map((item: any) => item.text)
    .join("/");
};
const formRef = ref();
const handleSubmit = () => {
  formRef.value.validate().then((res: any) => {
    submitLoading.value = true;
    request({
      url: "/order/address/save-or-update",
      method: "POST",
      data: {
        addressId: props.editId,
        phone: phone.value,
        userName: userName.value,
        detailAddress: detailAddress.value,
        province: result.value.split("/")[0],
        city: result.value.split("/")[1],
        country: result.value.split("/")[2],
        isDefault: isDefault.value ? 1 : 0,
      },
    })
      .then((res: any) => {
        if (res.code === 200) {
          emit("change");
        } else {
          Toast(res.message);
        }
      })
      .finally(() => {
        submitLoading.value = false;
      })
      .catch(() => {
        Toast("网络错误，请稍后重试");
      });
  });
};
if (props.editId) {
  //
  request({
    url: `/order/address/detail/${props.editId}`,
    method: "POST",
  })
    .then((res: any) => {
      userName.value = res.data.userName;
      phone.value = res.data.phone;
      detailAddress.value = res.data.detailAddress;
      isDefault.value = res.data.isDefault;
      result.value = `${res.data.province}/${res.data.city}/${res.data.country}`;
    })
    .catch(() => {
      Toast("网络错误，请稍后重试");
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: "收货地址",
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Form), {
        ref_key: "formRef",
        ref: formRef,
        "scroll-to-error": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(CellGroup), { inset: "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Field), {
                modelValue: userName.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((userName).value = $event)),
                name: "userName",
                label: "收货人",
                placeholder: "请填写收货人姓名",
                rules: [{ required: true, message: '请填写收货人' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(Field), {
                modelValue: phone.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((phone).value = $event)),
                type: "tel",
                maxlength: "11",
                name: "phone",
                label: "收货人",
                placeholder: "请输入你的手机号",
                rules: [{ required: true, message: '请输入你的手机号' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(Field), {
                modelValue: result.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((result).value = $event)),
                "is-link": "",
                readonly: "",
                name: "result",
                label: "地区选择",
                placeholder: "点击选择省市区",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showArea.value = true)),
                rules: [{ required: true, message: '请选择省市区' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(Popup), {
                show: showArea.value,
                "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showArea).value = $event)),
                position: "bottom"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Area), {
                    "area-list": _unref(areaList),
                    onConfirm: onConfirm,
                    onCancel: _cache[5] || (_cache[5] = ($event: any) => (showArea.value = false))
                  }, null, 8, ["area-list"])
                ]),
                _: 1
              }, 8, ["show"]),
              _createVNode(_unref(Field), {
                modelValue: detailAddress.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((detailAddress).value = $event)),
                name: "门牌号",
                label: "门牌号",
                placeholder: "例：6栋201室",
                rules: [{ required: true, message: '请输入门牌号' }]
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(Checkbox), {
          "icon-size": "18px",
          modelValue: isDefault.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isDefault).value = $event)),
          shape: "square"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(Button), {
        loading: submitLoading.value,
        round: "",
        block: "",
        class: "button",
        type: "primary",
        "native-type": "submit",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
}
}

})